/**
 * Browser beforeunload guard for unsaved Designer editors.
 * Extracted so the decide/apply logic is unit-testable without jsdom quirks.
 */

/** True when the page should warn on close/reload. */
export function shouldWarnBeforeUnload(hasDirtyTabs: boolean): boolean {
  return hasDirtyTabs
}

/**
 * Apply the standard beforeunload warning onto an event.
 * Returns true if a warning was applied.
 */
export function applyBeforeUnloadWarning(
  event: Pick<BeforeUnloadEvent, 'preventDefault'> & { returnValue?: string },
  hasDirtyTabs: boolean,
): boolean {
  if (!shouldWarnBeforeUnload(hasDirtyTabs)) return false
  event.preventDefault()
  // Chromium still requires a non-empty returnValue to show the native dialog.
  event.returnValue = ''
  return true
}

/**
 * Subscribe to window beforeunload. `getHasDirty` is read at event time
 * so callers don't need to re-bind on every dirty flip.
 * Returns an unsubscribe function.
 */
export function attachBeforeUnloadGuard(getHasDirty: () => boolean): () => void {
  const handler = (event: BeforeUnloadEvent) => {
    applyBeforeUnloadWarning(event, getHasDirty())
  }
  window.addEventListener('beforeunload', handler)
  return () => window.removeEventListener('beforeunload', handler)
}
